import {
  InvestigationModel,
  useGetInvestigationQuery,
} from '@customer/store/apis/investigationsApi';
import { useAppSelector } from '@customer/store/hooks';
import { skipToken } from '@reduxjs/toolkit/query';

interface UseLoadInvestigationReturn {
  investigation: InvestigationModel | undefined;
  isLoaded: boolean;
  renderKey: string;
}

export const useLoadInvestigation = (): UseLoadInvestigationReturn => {
  const siteId = useAppSelector(state => state.auth.siteId);
  const modelId = useAppSelector(state => state.global.sidePanelModelId);

  const { currentData: investigation } = useGetInvestigationQuery(
    siteId && modelId ? { siteId, investigationId: modelId } : skipToken,
    { refetchOnMountOrArgChange: true, refetchOnReconnect: true },
  );

  const isLoaded = typeof investigation !== 'undefined';
  const renderKey = JSON.stringify({ investigation });

  return {
    investigation,
    isLoaded,
    renderKey,
  };
};
